var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"crop",attrs:{"viewBox":"0 0 32 32"}},[_c('path',{attrs:{"d":"M26 8l6-6-2-2-6 6h-14v-6h-4v6h-6v4h6v16h16v6h4v-6h6v-4h-6v-14zM10 10h10l-10 10v-10zM12 22l10-10v10h-10z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }